import * as React from 'react'

import { useSiteConfig, useI18n } from '@thg-commerce/enterprise-core'
import { TextEntry, TextStyle } from '@thg-commerce/gravity-theme'
import { SafeHtml, Separator } from '@thg-commerce/gravity-elements'
import InformationSection, { StyledSafeHtml } from './InformationSection'

export const DeliveryAndReturnsInfo = ({
  showOnlyContent = false,
  deliveryMessageTextStyle,
  category,
}: {
  showOnlyContent?: boolean
  deliveryMessageTextStyle?: { entry: TextEntry; style: TextStyle }
  category?: string | null
}) => {
  const {
    showProductDeliveryAndReturnsInformation,
    showDeliveryAndReturnsInfoInAccordion,
    categoryToEnableKitchenApplianceDescription,
  } = useSiteConfig()
  const i18n = useI18n()

  if (
    !showProductDeliveryAndReturnsInformation &&
    !showDeliveryAndReturnsInfoInAccordion
  ) {
    return null
  }

  const useHBApplianceKey =
    categoryToEnableKitchenApplianceDescription &&
    category?.includes(categoryToEnableKitchenApplianceDescription)
      ? '.kitchen.appliance'
      : ''
  const i18nTextKey = `deliveryandreturnsinfo${useHBApplianceKey}`

  const i18nText = {
    deliveryTitle: i18n(`${i18nTextKey}.delivery.heading`),
    deliveryMessage: i18n(`${i18nTextKey}.delivery.message`),
    deliveryLegalMesage: i18n(`${i18nTextKey}.delivery.legalmessage`),
    returnsTitle: i18n(`${i18nTextKey}.returns.heading`),
    returnsMessage: i18n(`${i18nTextKey}.returns.message`),
  }

  return (
    <div data-testid="delivery-and-returns-info">
      <InformationSection title={i18nText.deliveryTitle}>
        {i18nText.deliveryMessage && (
          <StyledSafeHtml
            textStyle={deliveryMessageTextStyle}
            content={i18nText.deliveryMessage}
          />
        )}
        {i18nText.deliveryLegalMesage && (
          <SafeHtml content={i18nText.deliveryLegalMesage} />
        )}
      </InformationSection>

      <InformationSection title={i18nText.returnsTitle}>
        {i18nText.returnsMessage && (
          <SafeHtml content={i18nText.returnsMessage} />
        )}
      </InformationSection>

      {!showOnlyContent && <Separator withSpacing />}
    </div>
  )
}
